import { getDefaultExportFromCjs as r } from "./index.es117.js";
import { __require as o } from "./index.es118.js";
var t = o();
const m = /* @__PURE__ */ r(t);
export {
  m as default
};
//# sourceMappingURL=index.es26.js.map
